export default __webpack_public_path__ + "static/media/searchHC.9b54df12.svg";